
/*-----------------------
        CUSTOMER
---------------------- */
customer = {
    init: function () {
        $(".btn-forgot").on("click", function () {
            $(".customer.login").addClass("open-forgot");

        });

        $(".btn--cancel").on("click", function () {
            $(".customer.login").removeClass("open-forgot");

        });

        //ADDRESS
        $(".btn-add-address").on("click", function () {
            $("#AddAddress").toggleClass("open");
        });

        $(".btn-edit-address").on("click", function () {
            $(".edit--address").toggleClass("open");
        });
    }
};

login = {
    init: function () {
        $(".customer-form__form .forgot-pwd").on("click", function () {
            $(".customer-form__form").removeClass("active");
            $(".customer-form__form.form--recover").addClass("active");
        });

        $(".customer-form__form .cancel-recover").on("click", function () {
            $(".customer-form__form").removeClass("active");
            $(".customer-form__form.form--login").addClass("active");
        });
    }
};

address = {
    init: function () {
        // EDIT ADDRESS
        $(".address-item__actions .edit").on("click", function () {
            $(this).closest(".address-item").addClass("editing");
        });

        // ADD ADDRESS
        $(".new-address-btn").on("click", function () {
            $(".address-item.new-address").addClass("editing");
        });

        // CLOSE
        $(".address-item__edit .close-btn").on("click", function () {
            $(this).closest(".address-item").removeClass("editing");
        });

        $("body").on("click", function (event) {
            if (!$(event.target).closest('.address-item__edit').length && !$(event.target).closest('.address-item__actions').length && !$(event.target).closest('.new-address-btn').length) {
                $(".address-item").removeClass("editing");
            }
        });
    }
};

$(document).ready(function () {
    customer.init();
    login.init();
    address.init();
});
